import { Component, Input, OnInit } from '@angular/core';
import { Card } from '../../../models/card';
import { ProvinceNamePipe } from '../../shared/pipes/province-name.pipe';
import { CountryNamePipe } from '../../shared/pipes/country-name.pipe';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-shipment-card',
    templateUrl: './shipment-card.component.html',
    styleUrls: ['./shipment-card.component.scss'],
    imports: [UpperCasePipe, CountryNamePipe, ProvinceNamePipe]
})
export class ShipmentCardComponent implements OnInit {

  @Input()
  card: Card;

  constructor() { }

  ngOnInit(): void {
  }

}
